// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CQeD","col":"styles_col__iYqBT"};